import { render, staticRenderFns } from "./dialogUsageAgreement.vue?vue&type=template&id=1fb8ddad&scoped=true"
var script = {}
import style0 from "./dialogUsageAgreement.vue?vue&type=style&index=0&id=1fb8ddad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8ddad",
  null
  
)

export default component.exports